export default {
  sm: `
  데이터센터 각은 700년이 넘는 세월 동안
  팔만대장경을 지켜온 장경각의 정신을 이어갑니다.
  인류의 소중한 지식을 후대에 전한다는 막중한 책임과
  소명으로 네이버는 데이터센터의 이름을 ‘각’이라
  지었습니다.
  `,
  lg: `
  데이터센터 각은 700년이 넘는 세월 동안 팔만대장경을
  지켜온 장경각의 정신을 이어갑니다. 인류의 소중한 지식을
  후대에 전한다는 막중한 책임과 소명으로 네이버는
  데이터센터의 이름을 ‘각’이라 지었습니다.
  `,
  xxl: `
  데이터센터 각은 700년이 넘는 세월 동안 팔만대장경을 지켜온 장경각의 정신을
  이어갑니다. 인류의 소중한 지식을 후대에 전한다는 막중한 책임과 소명으로
  네이버는 데이터센터의 이름을 ‘각’이라 지었습니다.
  `,
};
